import react from 'react';
import { eventEmitter } from '@/utils/chatuiEvents';
import { getButtonAction, ButtonAction } from '@/utils/getButtonData';
import userStore from '@/stores/user';
import agentStore from '@/stores/agent';
import initStore from '@/stores/init';
import sessionStore from '@/stores/session';
import handleDmToLiveAgent from './handleDmToLiveAgent';
import { getCallbackParams } from '@/utils/common';
import { handleVirtualCall, handleSubmitWebform, handlePhoneCall } from '@/components/ChatbotUI/ChannelOptionButton';
import { getContent } from '@/utils/tools';
import { ENTRY_POINT } from '@/types/entryPoints';
import { getRedirectCallbackParams } from '@/components/ChatbotUI/Message';

enum NewButtonType {
  WebForm = 101,
  GeneralCall = 102,
  VirtualCall = 103,
  DmGeneralToLiveAgent = 104,
  ActionTypeToCaseSelect = 105,
}

export const MixActionType = { ...ButtonAction, ...NewButtonType };

// ActionTypeJumpURL = 1
// ActionTypeToLiveAgent = 4
// ActionTypeJumpIntent = 5
// ActionTypeToWebform = 101
// ActionTypeToGeneralCall = 102
// ActionTypeToVirtualCall = 103
// ActionTypeDmGeneralToLiveAgent = 104

export interface BasedActionHandleProps {
  // initStore: InitStore;
  // sessionStore: SessionStore;
  // agentStore: AgentStore;
  extra: any;
  isHistory?: boolean;
  dialogueId?: string;
  dialogueType?: string;
  nodePointId?: string;
  customCallback?: any;
}

const BasedActionHandle = (props: BasedActionHandleProps) => {
  const { extra, isHistory, dialogueId = '', dialogueType = '', customCallback } = props;
  const actionOptionInfo = extra?.action_option_info ?? {};
  const actionOption = actionOptionInfo?.action ?? {};
  const actionType = actionOptionInfo?.action_type ?? actionOption?.action_type;
  const liveOption = actionOptionInfo?.live_option_info;
  const buttonLive = liveOption?.button_for_live ?? {};
  const text = getContent(buttonLive);
  const sessionId = initStore.sessionId;
  const threadNodeId = extra?.thread_node_id;
  const jumpIntentData = actionOptionInfo?.jump_intent ?? {};
  const actionFunc = getButtonAction(actionType);
  const taskbotInfo = actionOption?.task_bot_action?.current_task_bot_info ?? {};
  const callbackAction = actionOptionInfo?.callback_action ?? {};
  const params = {
    ...actionOptionInfo,
    action: {
      ...actionOption,
      nextParams: { ...getCallbackParams(extra) },
      info: {
        taskbotInfo,
        dialogueId,
      },
      customCallback,
      func: actionFunc,
      taskbotInfo,
      buttonInfo: { ...actionOptionInfo },
    },
    text: actionOptionInfo?.button_text ?? jumpIntentData.text,
  };
  if (params.action.buttonInfo.callback_action) {
    params.action.buttonInfo.callback_action = {
      ...getRedirectCallbackParams({
        action: params.action,
        btn: actionOptionInfo,
        props: {
          ...customCallback,
          sessionId,
          dialogueId,
          taskbotInfo,
          threadNodeId,
        }
      })
    };
  }

  switch (actionType) {
    case MixActionType.JumpIntent:
      params.action.nextParams = {
        ...params.action.nextParams,
        ...jumpIntentData,
      };
      params.text = jumpIntentData.text;
      eventEmitter.emit(actionFunc, params, { notDialogue: true });
      break;
    case MixActionType.DmGeneralToLiveAgent:
      handleDmToLiveAgent(props);
      break;
    case MixActionType.JumpURL:
    case MixActionType.JumpFormstack:
    case MixActionType.ToLiveAgent:
      params.action = {
        ...params.action,
        ...actionOption,
      };
      eventEmitter.emit(actionFunc, params, { notDialogue: true });
      break;
    case MixActionType.WebForm:
      handleSubmitWebform(
        text,
        {
          dialogueId,
          dialogueType,
          sessionId,
        },
        customCallback,
        true,
      );
      break;
    case MixActionType.GeneralCall:
      handlePhoneCall(
        text,
        {
          dialogueId,
          dialogueType,
          sessionId,
          phoneNumber: buttonLive?.extra_param?.phone_number,
        },
        true,
      );
      break;
    case MixActionType.VirtualCall:
      handleVirtualCall(
        text,
        {
          dialogueId,
          dialogueType,
          entryPoint: ENTRY_POINT[initStore?.from as any] ?? ENTRY_POINT.general,
          businessId: initStore?.sessionId,
          userType: agentStore?.userType,
          enquiryType: agentStore?.enquiryType,
          orderSn: agentStore?.inboundOrderSn,
          reasonCode: agentStore?.reasonCodeL1Id,
          userTypeLabel: agentStore?.userTypeLabel,
        },
        customCallback,
        true,
      );
      break;
    case MixActionType.ActionTypeToCaseSelect:
      // userStore.HANDLE_CASE_CLICK_FETCH();
      sessionStore.UPDATE_DIALOGUE({
        obj: { caseActive: true },
        index: sessionStore.getCurPos() - 1, // 这里直接当前位置 -1 是因为 识别只识别上一条的 信息
      });
      break;
    default:
      params.action.nextParams = {
        ...params.action.nextParams,
        ...jumpIntentData,
      };
      eventEmitter.emit(actionFunc, params, { notDialogue: true });
      break;
  };

  return null;
};

// export default inject(getChildInject('initStore', 'sessionStore', 'agentStore'))(observer(BasedActionHandle));
export default BasedActionHandle;
